import Axios from 'axios'
import server from 'util/Server'

export const GetCupones = (params: any) => {
     return Axios.get(`${server.host!}8014/api/v1/gestion-cupones/obtener`, { params, headers: { Authorization: server.obtenerToken() } })
}

export const GetEstadosCupones = () => {
     return Axios.get(`${server.host!}8014/api/v1/gestion-cupones/estados`, { headers: { Authorization: server.obtenerToken() } })
}

export const PutGenerarCupon = (params: any) => {
     return Axios.put(`${server.host!}8014/api/v1/gestion-cupones/generar?cupon_id=${params.cupon_id}&usuario_responsable_id=${params.usuario_responsable_id}&cupon_administrativo=${params.cupon_administrativo}`, { headers: { Authorization: server.obtenerToken() } })
}